import { Link } from "react-router-dom";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import type { StockMovement } from "../types/stock-movement.types";

export type StockMovementActionsDropdownProps = {
  record: StockMovement;
  canRead: boolean;
};

export default function StockMovementActionsDropdown({
  record,
  canRead,
}: StockMovementActionsDropdownProps) {
  if (!canRead) {
    return <span className="text-muted small">—</span>;
  }

  return (
    <UncontrolledDropdown>
      <DropdownToggle
        type="button"
        className="btn btn-soft-secondary btn-sm"
        tag="button"
        aria-label="Stock movement actions"
      >
        <i className="ri-more-2-fill align-middle" />
      </DropdownToggle>
      <DropdownMenu container="body" end>
        <DropdownItem
          tag={Link}
          to={`/inventory-management/stock-movements/${record.id}`}
        >
          <i className="ri-eye-line align-bottom me-2 text-muted" />
          View
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}
